export class AccountDataApi {
    client;
    constructor(client) {
        this.client = client;
    }
    async getDataExport() {
        return this.client.get('/api/account/data-export');
    }
    async requestDeletion() {
        return this.client.post('/api/account/delete/request', {});
    }
    async confirmDeletion(code) {
        return this.client.post('/api/account/delete/confirm', { code });
    }
}
//# sourceMappingURL=account-data-api.js.map